import {
  useMutation,
} from '@tanstack/react-query';
import { http } from '../config';
import {
  IDeleteAccountPostResponse,
  IEditUserInfoPutRequestPayload,
  IEditUserInfoPutResponse,
  ListSessionsTokensGetResponse,
  IResendOtpPostRequestPayload,
  IResendOtpPostResponse,
} from '../../types';
import { toast } from 'react-toastify';
import { logoutHandler, userDataMapper } from '../../utils';
import { useStoreUserData } from '../../hooks';

interface IAuth {
  deleteAccount: () => Promise<IDeleteAccountPostResponse>;
  listSessions: () => Promise<ListSessionsTokensGetResponse>;
  editUserInfo: (
    payload: IEditUserInfoPutRequestPayload
  ) => Promise<IEditUserInfoPutResponse>;
  resendOtp: (
    payload: IResendOtpPostRequestPayload
  ) => Promise<IResendOtpPostResponse>;
}
export const auth: IAuth = {
  deleteAccount: () =>
    http.criticalPost(`/api/auth/customer_portal/delete-account`),
  listSessions: () => http.get(`/api/auth/customer_portal/session-tokens`),
  editUserInfo: (payload) =>
    http.put(`/api/auth/customer/update-info`, payload),
  resendOtp: (payload) => http.post(`/api/auth/customer/resend_otp`, payload),
};

export const useDeleteAccount = () => {
  return useMutation({
    mutationKey: ['auth-deleteAccount'],
    mutationFn: () => auth.deleteAccount(),
    onSuccess: (response) => {
      logoutHandler();
      toast.success(response.detail);
    },
    onError: (error) => {
      const err = error as unknown as {
        response: { data: { message: string } };
      };
      toast.error(err.response.data.message);
    },
  });
};

export const useListSessions = () => {
  return useMutation({
    mutationKey: ['auth-listSessions'],
    mutationFn: () => auth.listSessions(),
  });
};

export const useEditUserInfo = () => {
  const  handler = useStoreUserData();
  
  return useMutation({
    mutationKey: ['auth-edit-user-info'],
    mutationFn: auth.editUserInfo,
    onSuccess: (res) => {
      toast.success(res.message);
      if(res.full_name !== undefined){
        const profile = userDataMapper(res, 'VERIFIED' );
  
        handler({
          data: profile
        });
      }      
    },
    onError: (error) => {
      const err = error as unknown as {
        response: { data: { message?: string; error?: string } };
      };
      toast.error(err.response.data.message || err.response.data.error);
    },
  });
};

export const useResendOtp = () => {
  return useMutation({
    mutationKey: ['auth-resend-otp'],
    mutationFn: auth.resendOtp,
    onSuccess: (data) => {
      const message = data.message.replace('to email', 'to email:\n').replace('to phone', 'to phone:\n');
      toast.success(message || 'OTP resent successfully', {
        style: {
          wordBreak: 'break-all',  
          overflowWrap: 'anywhere',  
          whiteSpace: 'pre-line',    
        },
      });
    },
  });
};
